/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  INITIATE_CREATE_SUPPLIER: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.trag.create-supplier',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        MUTATE: { target: 'INITIATE_CREATE_SUPPLIER' },
      },
    },
    INITIATE_CREATE_SUPPLIER: {
      invoke: {
        id: 'createSupplier',
        src: 'createSupplier',
        onDone: {
          target: 'INITIATE_CREATE_SUPPLIER_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'INITIATE_CREATE_SUPPLIER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    INITIATE_CREATE_SUPPLIER_SUCCESS: {
      on: {
        MUTATE: { target: 'INITIATE_CREATE_SUPPLIER' },
      },
    },
    INITIATE_CREATE_SUPPLIER_FAILED: {
      on: {
        MUTATE: { target: 'INITIATE_CREATE_SUPPLIER' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
